// Countdown Widget
// Finds every .countdown-widget[data-end], ticks it once a second, and switches
// to an "expired" state when the target passes. Each element is claimed via a
// data-cd-bound flag so it never initialises twice (safe alongside the
// standalone assets/js/countdown-widget.js).

function pad(n) {
  return (n < 10 ? "0" : "") + n;
}

function initWidget(widget) {
  if (widget.dataset.cdBound === "1") return;
  widget.dataset.cdBound = "1";

  const end = Date.parse(widget.getAttribute("data-end"));
  if (Number.isNaN(end)) return;

  const daysEl = widget.querySelector("[data-days]");
  const hoursEl = widget.querySelector("[data-hours]");
  const minutesEl = widget.querySelector("[data-minutes]");
  const secondsEl = widget.querySelector("[data-seconds]");
  const expiredEl = widget.querySelector(".countdown-widget__expired");

  let interval = null;

  function expire() {
    if (interval) clearInterval(interval);
    widget.classList.add("is-expired");
    if (expiredEl) {
      expiredEl.hidden = false;
    } else {
      const wrap = widget.closest(".countdown-widget-wrap");
      if (wrap) wrap.style.display = "none";
    }
  }

  function tick() {
    const distance = end - Date.now();

    if (distance <= 0) {
      [daysEl, hoursEl, minutesEl, secondsEl].forEach((el) => {
        if (el) el.textContent = "00";
      });
      expire();
      return;
    }

    const days = Math.floor(distance / 86400000);
    const hours = Math.floor((distance % 86400000) / 3600000);
    const minutes = Math.floor((distance % 3600000) / 60000);
    const seconds = Math.floor((distance % 60000) / 1000);

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }

  tick();
  interval = setInterval(tick, 1000);
}

export default function initCountdownWidgets(root) {
  const scope = root || document;
  scope.querySelectorAll(".countdown-widget[data-end]").forEach(initWidget);
}
